export const topLevelNodes = (nodes = [], edges = []) => {
    const sourceTargetMap = edges.reduce((a,edge) => {
        if (a[edge?.target] === undefined) {
            a[edge?.target] = {}
        }

        a[edge?.target][edge?.source] = edge?.targetHandle
        return a
    }, {})

    return nodes?.filter(x => sourceTargetMap[x?.id] === undefined)
}

export const entryPoints = (topLevel) => topLevel?.reduce((a, c) => {
    const inputs = c?.data?.inputs?.map(k => {
        return ({
            id: k?.id,
            type: k?.type,
            name: k?.name,
            nodeId: c?.id,
        })
    }).flat()
    if (a.nodes[c?.id] === undefined) {
        a.nodes[c?.id] = []
        a.info[c?.id] = {
            nodeDescription: c?.data?.description,
            nodeId: c?.id,
            nodeName: c?.data?.name,
        }
    }

    a.nodes[c?.id] = inputs

    return a
}, { nodes: {}, info: {} })

export const getIO = (nodes = [], edges = []) => {
    const sourceTargetMap = edges.reduce((a,c) => {
        if(a[c?.source] === undefined) {
            a[c?.source] = {}
        }
        a[c?.source] = c?.target

        return a
    }, {})

    const inputNodes = topLevelNodes(nodes, edges)
    const outputNodes = nodes.filter(x => sourceTargetMap[x?.id] === undefined)

    return {
        inputs: inputNodes.map(x => x.data?.inputs.map(j => ({ ...j, use_as_edge: true, nodeId: x?.id, nodeName: x?.data?.name, }))).flat(),
        outputs: outputNodes.map(x => x.data?.outputs.map(j => ({ ...j, nodeId: x?.id }))).flat(),        
    }
}